import React from 'react';
import './Icon.scss';
const rootClassName = 'icon-component';

export const EvidenciasIcon = () => {
  return (
    <svg
      className={rootClassName}
      viewBox='0 0 26 25'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.2647 0.31253L3.96786 6.3344C3.94987 6.35197 3.93252 6.37001 3.91583 6.38849C3.73565 6.5316 3.62012 6.7526 3.62012 7.00057C3.62012 7.02381 3.62113 7.04681 3.62312 7.06953C3.62126 7.09588 3.62032 7.12239 3.62032 7.14902V22.8303C3.62032 24.0278 4.59235 24.999 5.79063 24.999H19.4203C20.6186 24.999 21.5906 24.0278 21.5906 22.8303V2.16934C21.5906 0.971835 20.6186 -0.000976562 19.4203 -0.000976562H11.0438C11.0151 -0.000976562 10.9866 0.00012401 10.9583 0.00229515C10.9411 0.00115754 10.9238 0.00057745 10.9063 0.000572792C10.6761 0.00051154 10.4692 0.0999515 10.3262 0.258233C10.3081 0.273136 10.2904 0.288615 10.2731 0.304654L10.2647 0.31253ZM10.1243 2.60879L6.34887 6.21932H10.1234L10.1243 2.60879ZM5.18282 7.78182V22.8303C5.18282 23.1645 5.45502 23.4365 5.79063 23.4365H19.4203C19.7559 23.4365 20.0281 23.1645 20.0281 22.8303V2.16934C20.0281 1.83451 19.7554 1.56152 19.4203 1.56152H11.6871L11.6857 6.65214C11.6857 7.27579 11.1797 7.78182 10.5561 7.78182H5.18282Z'
      />
    </svg>
  );
};
